import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
	Box,
	Typography,
	Divider,
	TextField,
} from "@mui/material";
import { MergeConflictModalProps } from "./MergeConflictModal.types";
import { useMergeConflictModalViewModel } from "./MergeConflictModal.vm";
import "./MergeConflictModal.css";

export const MergeConflictModal: React.FC<MergeConflictModalProps> = (props) => {
	const { open, conflicts, onCancel } = props;
	const vm = useMergeConflictModalViewModel(props);

	return (
		<Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth className="merge-conflict-modal">
			<DialogTitle>Resolve Merge Conflicts</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" className="description">
					The selected jobs have different values for the following fields. Please choose which value to keep for each
					field.
				</Typography>
				<Box className="conflicts-container">
					{conflicts.map((conflict, index) => (
						<React.Fragment key={conflict.propertyKey}>
							{index > 0 && <Divider />}
							<FormControl component="fieldset">
								<FormLabel component="legend" className="conflict-label">
									{conflict.displayName}
								</FormLabel>
								<RadioGroup
									value={
										vm.isUsingCustomText[conflict.propertyKey]
											? "__custom__"
											: JSON.stringify(vm.selections[conflict.propertyKey])
									}
									onChange={(e) => {
										if (e.target.value === "__custom__") {
											vm.handleToggleCustomText(conflict.propertyKey, true);
										} else {
											const option = conflict.options.find((opt) => JSON.stringify(opt.value) === e.target.value);
											if (option) {
												vm.handleSelectionChange(conflict.propertyKey, option.value);
											}
										}
									}}
								>
									{conflict.options.map((option, optIndex) => (
										<FormControlLabel
											key={optIndex}
											value={JSON.stringify(option.value)}
											control={<Radio size="small" />}
											label={
												<Box>
													<Typography variant="body2" component="span">
														{vm.formatValue(conflict.propertyKey, option.value)}
													</Typography>
													<Typography variant="caption" color="text.secondary" component="span" className="job-source">
														(from {option.jobLabel})
													</Typography>
												</Box>
											}
										/>
									))}
									{vm.isTextField(conflict.propertyKey) && (
										<>
											<FormControlLabel
												value="__custom__"
												control={<Radio size="small" />}
												label={
													<Typography variant="body2" component="span">
														Enter custom value
													</Typography>
												}
											/>
											{vm.isUsingCustomText[conflict.propertyKey] && (
												<TextField
													size="small"
													placeholder="Enter value..."
													value={vm.customTextValues[conflict.propertyKey] || ""}
													onChange={(e) => vm.handleCustomTextChange(conflict.propertyKey, e.target.value)}
													className="custom-text-input"
													autoFocus
												/>
											)}
										</>
									)}
								</RadioGroup>
							</FormControl>
						</React.Fragment>
					))}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} color="inherit">
					Cancel
				</Button>
				<Button onClick={vm.handleConfirm} variant="contained" disabled={!vm.allResolved}>
					Merge Jobs
				</Button>
			</DialogActions>
		</Dialog>
	);
};
